import { Component, computed, input, OnInit } from '@angular/core';
import { AudioPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-mechanic-title',
  imports: [],
  templateUrl: './rid-mechanic-title.html',
  host: {
    class: 'block absolute top-8 w-full',
    'animate.enter': 'anim-fade-from-top',
    'animate.leave': 'anim-fade-to-top',
  },
})
export class RidMechanicTitle implements OnInit {
  title = input<string | { text: string; audioUrl?: string }>();

  protected text = computed(() => {
    const title = this.title();
    return typeof title === 'string' ? title : title?.text;
  });

  ngOnInit() {
    const text = this.title();

    if (typeof text !== 'string') {
      if (text?.audioUrl) {
        AudioPlayer.play(text.audioUrl);
      }
    }
  }
}
